export const notifications_sounds = [
  {
    id: "default",
    name: "WhatsApp1",
    url: "https://skyticketstorage.blob.core.windows.net/src/whatsapp-short-ringtone.mp3",
  },
  {
    id: "whatsapp2",
    name: "WhatsApp2",
    url: "https://skyticketstorage.blob.core.windows.net/src/whatsapp-message-sound-effect-4-386096.mp3",
  },
  {
    id: "whatsapp3",
    name: "WhatsApp3",
    url: "https://skyticketstorage.blob.core.windows.net/src/whatsapp-message-for-iphone.mp3",
  },
  {
    id: "ting",
    name: "Ting",
    url: "https://skyticketstorage.blob.core.windows.net/src/text-message-ting-1757240390492-402365.mp3",
  },
  {
    id: "sparckle",
    name: "Sparckle",
    url: "https://skyticketstorage.blob.core.windows.net/src/text-message-sparckle-4-1757809550283-404576.mp3",
  },
  {
    id: "message-effect",
    name: "Efecto Mensaje",
    url: "https://skyticketstorage.blob.core.windows.net/src/text-message-sound-effect-5-386088.mp3",
  },
  {
    id: "incoming-msg",
    name: "Mensaje Entrante",
    url: "https://skyticketstorage.blob.core.windows.net/src/incoming_msg.mp3",
  },
  {
    id: "ping",
    name: "Ping",
    url: "https://skyticketstorage.blob.core.windows.net/src/happy-message-ping-351298.mp3",
  },
];

export function getSoundFileById(toneId) {
  const sound = notifications_sounds.find((s) => s.id === toneId);
  return sound?.url || notifications_sounds[0].url; 
};

export function getSoundIdByUrl(url) {
  const sound = notifications_sounds.find((s) => s.url === url);
  return sound?.id || notifications_sounds[0].id;
};

// Helpers null-aware: una URL vacía/ausente significa "sin tono" (null),
// no el tono por defecto. Los helpers de arriba caen al fallback; estos no.
export const toneIdToUrl = (id) => (id ? getSoundFileById(id) : null);

export const toneUrlToId = (url) => (url ? getSoundIdByUrl(url) : null);